import RenderTypeahead from "./RenderTypeahead";

export default RenderTypeahead;
